<div class="row d-none">
    <div class="col-12 col-lg-6">
        <app-table-content [isBuy]="true"></app-table-content>
    </div>
    <div class="col-12 col-lg-6">
        <app-table-content></app-table-content>
    </div>
</div>